import type { InviteRecipientStatus, RsvpResponseValue } from '@peles/shared';

/** Where an invitation stands, in words a host uses, and its badge colour. */
export const RECIPIENT_STATUS: Record<InviteRecipientStatus, { label: string; color: string }> = {
  PENDING: { label: 'Not sent', color: '#94a3b8' },
  QUEUED: { label: 'Queued', color: '#94a3b8' },
  SENT: { label: 'Sent', color: '#3b82f6' },
  DELIVERED: { label: 'Delivered', color: '#3b82f6' },
  OPENED: { label: 'Opened', color: '#8b5cf6' },
  RESPONDED: { label: 'Answered', color: '#22c55e' },
  BOUNCED: { label: 'Bounced', color: '#ef4444' },
  FAILED: { label: 'Failed', color: '#ef4444' },
};

export const RESPONSE_BADGE: Record<RsvpResponseValue, { label: string; color: string }> = {
  YES: { label: 'Coming', color: '#22c55e' },
  MAYBE: { label: 'Maybe', color: '#f59e0b' },
  NO: { label: 'Not coming', color: '#ef4444' },
  PENDING: { label: 'No answer', color: '#94a3b8' },
};
